import { z } from "zod";

export const CreateRoomTypeSchema = z.object({
    name: z.string().nonempty('Room type name is required'),
    description: z.string().optional(),
    occ_adults: z.coerce.number().int().min(1, 'Adults number must be greater than 0'),
    occ_children: z.coerce.number().int().min(0, 'Children number must be 0 or greater'),
    total_rooms: z.coerce.number().int().min(1, 'Total rooms must be greater than 0'),
    room_number: z.array(z.string()).superRefine((roomNumbers, ctx) => {
        roomNumbers.forEach((roomNumber, index) => {
            if (roomNumber === "") {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `Room number at position ${index + 1} is required`,
                    path: [index],
                });
            }
        });
    }),
}).superRefine((data, ctx) => {
    // count total room numbers array and compare with total_rooms must be equal
    if (data.room_number.length !== data.total_rooms) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: `Room number must be equal to total rooms`,
            path: ["total_rooms"],
        });
    }
});

export type CreateRoomType = z.infer<typeof CreateRoomTypeSchema>;